import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'cp-base',
    templateUrl: './base.component.html',
    styleUrls: ['./base.component.less'],
    standalone: false
})
export class BaseComponent implements OnDestroy {
    protected subscriptions: Subscription[] = [];

    constructor() {}

    ngOnDestroy(): void {
        this.subscriptions.forEach((s: Subscription) => s.unsubscribe())
    }

    protected handleError(error: any): void {
        console.error('An error occurred', error);
    }
}
